import { useEffect, useState } from "react";
import { Lightbulb, Volume2 } from "lucide-react";
import { playVoice } from "@/lib/tts";

// "Ed mwa": short Kreol Morisien hint (admin-approved, never the answer), shown and read with the French voice.
export default function KreolHint({ hint, big = false, onUse }) {
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(false), [hint]);
  if (!hint) return null;
  const show = () => { if (!open && onUse) onUse(); setOpen(true); playVoice(hint, "fr"); };
  return (
    <div className="mt-3" data-testid="kreol-hint">
      <button onClick={show} data-testid="kreol-hint-btn"
        className={`inline-flex items-center gap-2 rounded-full bg-amber-300 border-2 border-slate-900 font-bold shadow-[3px_3px_0_0_#0F172A] active:translate-x-0.5 active:translate-y-0.5 transition-transform ${big ? "px-5 py-2.5 text-lg" : "px-4 py-2 text-sm"}`}>
        <Lightbulb size={big ? 22 : 16} /> Ed mwa
      </button>
      {open && (
        <div className={`mt-2 rounded-2xl border-2 border-slate-900 bg-amber-50 p-3 flex items-start gap-2 ${big ? "text-xl" : "text-base"}`} data-testid="kreol-hint-text">
          <span className="flex-1 font-semibold">{hint}</span>
          <button onClick={() => playVoice(hint, "fr")} aria-label="Ekout ankor" data-testid="kreol-hint-replay"
            className="w-9 h-9 shrink-0 rounded-full bg-white border-2 border-slate-900 flex items-center justify-center">
            <Volume2 size={18} />
          </button>
        </div>
      )}
    </div>
  );
}
